var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9779 10.6214C25.066 9.07554 22.7596 9.12793 21.9423 10.7785L21.9415 10.78L18.519 17.6715L10.872 18.7786C8.99366 19.0476 8.21976 21.3788 9.60383 22.7091L9.6065 22.7117L15.1251 28.0631L13.8238 35.6295C13.4984 37.5084 15.4707 38.9439 17.1572 38.0623L24.0076 34.4789L30.8577 38.0622C32.5442 38.9438 34.5169 37.5091 34.1915 35.6302L32.8901 28.0631L38.4087 22.7117L38.4115 22.709C39.7872 21.3865 39.0436 19.049 37.1437 18.7786L37.1416 18.7783L29.4962 17.6715L26.0728 10.7782C26.0453 10.7228 26.0135 10.6704 25.9779 10.6214Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarFilled);
export default __webpack_public_path__ + "static/media/icon_star_filled.bbaadb5f.svg";
export { ForwardRef as ReactComponent };